import { Measurement, RawMeasurement } from "@/types/measurement";

export const mapRawToMeasurement = (raw: RawMeasurement): Measurement => {
  return {
    id: raw.id,
    portComboId: raw.port_combo_id,
    waferRequestId: raw.wafer_request_id,
    experiment: raw.experiment,
    maxStep: raw.max_step,
    timestamp: new Date(raw.timestamp),
    portCombo: {
      id: raw.port_combo.id,
      index: raw.port_combo.index,
      blindStep: raw.port_combo.blind_step,
      structure: {
        id: raw.port_combo.structure.id,
        name: raw.port_combo.structure.name,
        subDieName: raw.port_combo.structure.sub_die_name,
        testSiteName: raw.port_combo.structure.test_site_name,
      },
    },
    waferRequest: raw.wafer_request
      ? {
          id: raw.wafer_request.id,
          wafer: {
            id: raw.wafer_request.wafer.id,
            name: raw.wafer_request.wafer.name,
          },
          measurementSystem: raw.wafer_request.measurement_system
            ? {
                id: raw.wafer_request.measurement_system.id,
                name: raw.wafer_request.measurement_system.name,
              }
            : null,
        }
      : null,
    outputs: raw.outputs.map((output) => ({
      id: output.id,
      dieRow: output.die_row,
      dieColumn: output.die_column,
      measurementId: output.measurement_id,
      opticalPortId: output.optical_port_id,
      opticalPort: {
        id: output.optical_port.id,
        name: output.optical_port.name,
      },
      alignSuccess: output.align_success,
      alignedPower: output.aligned_power,
      x: output.x,
      y: output.y,
      z: output.z,
      xNano: output.x_nano,
      yNano: output.y_nano,
      zNano: output.z_nano,
      h: output.h,
      step: output.step ?? 0,
      overtravel: output.overtravel,
      rotation: output.rotation,
    })),
    logEvents: raw.log_events.map((event) => ({
      id: event.id,
      type: event.type,
      message: event.message,
      emails: event.emails.map((email) => email.email),
    })),
  };
};
